import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import classes from '@nerdwallet/base-styles/classes';
import { Divider } from '../Divider/Divider';
import { Box } from '../Box/Box';
export var Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
      className = _ref.className,
      dividers = _ref.dividers,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["spacing", "className", "dividers", "children"]);

  var flattenedChildren = flattenChildren(children);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: ref
  }, otherProps), flattenedChildren.map(function (child, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      // Default to child.key to enable users to opt in to keyed
      // children. Since the `React.ReactChild` type includes the
      // `string` type, we need to cast the child to `any` to avoid a
      // TypeScript error.
      key: child.key || index
    }, /*#__PURE__*/React.createElement(Box, {
      marginBottom: index !== flattenedChildren.length - 1 ? spacing : undefined,
      marginTop: index !== 0 ? spacing : undefined
    }, child), dividers && index !== flattenedChildren.length - 1 && /*#__PURE__*/React.createElement(Divider // TODO: in currency v2, this should no longer be necessary
    , {
      className: classes('margin-vertical-0'),
      level: dividers
    }));
  }));
});
Stack.displayName = 'Stack';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  Stack.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    dividers: PropTypes.oneOf([1, 2, 3]),

    /**
     * The fixed-amount of vertical space between each child element.
     */
    spacing: PropTypes.oneOf([0, 1, 2, 3, '3-half', 4, 5])
  };
}